import { useEffect } from 'react';
import { useQuery } from '@tanstack/react-query';
import { fetchCurrentUser } from './auth.ts';
import { forgetAppTheme } from './appTheme.ts';
import { isSessionRefusal } from './session.ts';
import { useAppTheme } from './useAppTheme.ts';
import { useFeatureFlag } from './useFeatureFlag.ts';

/**
 * The signed-in person's theme, applied from the root route of either app.
 * Without a session the stored choice is dropped, so a signed-out screen is
 * light however the session ended. `skip` leaves the theme as it is.
 */
export function useUserTheme({ skip = false }: { skip?: boolean } = {}): void {
  const { data: user, error } = useQuery({
    queryKey: ['currentUser'],
    queryFn: fetchCurrentUser,
  });
  const darkModeEnabled = useFeatureFlag('dark_mode', user !== undefined);

  const signedOut = isSessionRefusal(error);
  useEffect(() => {
    if (signedOut) forgetAppTheme();
  }, [signedOut]);

  useAppTheme(skip ? undefined : user?.theme, darkModeEnabled);
}
